import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { PublicRolePermissionInfo, Role, RolePermission } from '../../../../shared/helpers/permissions';
import { PermissionsState } from './types';

type PermissionsSlice = PermissionsState | null;

const initialState = null as PermissionsSlice;

const permissionsSlice = createSlice({
    name: 'permissions',
    initialState,
    reducers: {
        updatePermissions(state, action: PayloadAction<PermissionsState>) {
            if (state && state.version >= action.payload.version) {
                return;
            }
            return action.payload;
        },
        updateLocalMembersPermissions(state, action: PayloadAction<RolePermission[]>) {
            if (!state) {
                return;
            }

            state.publicRolePermissions = [
                ...state.publicRolePermissions.filter((info) => info.role !== Role.MEMBER),
                {
                    role: Role.MEMBER,
                    allowed: action.payload,
                } as PublicRolePermissionInfo,
            ];
        },
        resetPermissions() {
            return initialState;
        },
    },
});

export const { updatePermissions, updateLocalMembersPermissions, resetPermissions } = permissionsSlice.actions;
export const permissionsReducer = permissionsSlice.reducer;
export const setRecordingForMembersAllowed = createAction<boolean>(
    'conference/permissions/setRecordingForMembersAllowed'
);
export const setCloudRecordingForMembersAllowed = createAction<boolean>(
    'conference/permissions/setCloudRecordingForMembersAllowed'
);
export const setSummarizationForMembersAllowed = createAction<boolean>(
    'conference/permissions/setSummarizationForMembersAllowed'
);
export const setCalendarSummarizationForMembersAllowed = createAction<boolean>(
    'conference/permissions/setCalendarSummarizationForMembersAllowed'
);
